export default {
  fillSvaEditing({ state, commit }, sva) {
    commit("setSvaName", sva.name)
    commit("setSvaPrice", sva.value)
    commit("setSvaActive", sva.active)
    commit("setSvaCategorySelected", sva.category)
    commit("setSvaScore", sva.score)
    commit("setSvaRelatedPlans", sva.related_plans)
    if (sva.icon) {
      commit("setSvaIconPreview", { url: sva.icon, icon: "" })
    }
    commit(
      "setSvaSelecteds",
      sva.inhibitions.map(sva => ({
        text: sva.name,
        value: sva.uuid,
        uuid: sva.uuid
      }))
    )
  }
}
